export interface JobCommand{
    action?:Action;
    jobId?:number;
    cardId?:number;
}

export enum Action{
    new,
    update,
    copy
}

export interface CreateJobImageCommand{
    jobId:number;
    imageId:number;
}